import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0383ccd5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Login")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Entrar com o Google")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Entrar com o Facebook")

import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useLoading } from '@/composables'
import { AlertNotification } from '@/components'
import useLogin from '../composables/useLogin'
import { FormLogin } from '@/@types'
import AuthModeLink from './AuthModeLink.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { isPending, notification, login, loginWithGoogle, loginWithFacebook } =
  useLogin()
const router = useRouter()
const { overlayLoading } = useLoading()
const formData = ref<FormLogin>({
  email: 'beto@groo.com',
  password: '123456'
})

watch(
  () => isPending.value,
  () => {
    overlayLoading(isPending.value)
  }
)

const handleSubmit = async () => {
  await login(formData.value)
  if (!notification.value.error) router.push({ name: 'Profile' })
}

const handleClick = async (mode: 'google' | 'meta') => {
  if (mode === 'google') await loginWithGoogle()
  if (mode === 'meta') await loginWithFacebook()
  if (!notification.value.error) router.push({ name: 'Profile' })
}

return (_ctx: any,_cache: any) => {
  const _component_AppTextfield = _resolveComponent("AppTextfield")!
  const _component_app_btn = _resolveComponent("app-btn")!
  const _component_app_divider = _resolveComponent("app-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      onSubmit: _withModifiers(handleSubmit, ["prevent"])
    }, [
      _createVNode(_component_AppTextfield, {
        placeholder: "Email",
        modelValue: formData.value.email,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.email) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_AppTextfield, {
        type: "password",
        placeholder: "Senha",
        modelValue: formData.value.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.password) = $event))
      }, null, 8, ["modelValue"]),
      _hoisted_2,
      _createVNode(_component_app_btn, null, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_app_divider, { text: "ou" }),
      _createVNode(_component_app_btn, {
        block: "",
        color: "red",
        variant: "outlined",
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (handleClick('google')), ["prevent"]))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_app_btn, {
        block: "",
        color: "blue-darken-4",
        variant: "outlined",
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (handleClick('meta')), ["prevent"]))
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ], 40, _hoisted_1),
    _createVNode(_component_app_divider),
    _createElementVNode("div", null, [
      _createVNode(AuthModeLink, {
        text: "Ainda não em cadastro?",
        textLink: "Cadastre-se",
        to: { name: 'Welcome', params: { mode: 'signup' } }
      }),
      _createVNode(AuthModeLink, {
        text: "Esqueceu a senha?",
        textLink: "Redefina",
        to: { name: 'Welcome', params: { mode: 'reset' } }
      })
    ]),
    (_unref(notification).type)
      ? (_openBlock(), _createBlock(_unref(AlertNotification), {
          key: 0,
          type: _unref(notification).type,
          message: _unref(notification).message
        }, null, 8, ["type", "message"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})